import { useTranslation } from 'react-i18next'

import { CheckIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip } from '@reveni-io/reveni-ui'

const CompletedInfoChip = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Chip
      label={t('Completado')}
      backgroundColor={theme.colors.success.surface}
      color={theme.colors.outline.default}
      Icon={CheckIcon}
    />
  )
}

export default CompletedInfoChip
